// components/MenuItemsTable/ScheduleOrderModal.js
import React from 'react';
import toast from 'react-hot-toast';

const ScheduleOrderModal = ({
  isOpen,
  onClose,
  scheduleDate,
  setScheduleDate,
  scheduleTime,
  setScheduleTime,
  onConfirm
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!scheduleDate || !scheduleTime) {
      toast.error("Please select both date and time");
      return;
    }

    const scheduleDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
    const now = new Date();
    const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

    if (scheduleDateTime < twoHoursLater) {
      toast.error("Schedule time must be at least 2 hours from now");
      return;
    }

    onConfirm();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '24px',
        width: '90%',
        maxWidth: '400px'
      }}>
        <h3 style={{ margin: '0 0 20px 0', color: '#ee6521' }}>Schedule Order</h3>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px' }}>Select Date</label>
          <input
            type="date"
            value={scheduleDate}
            onChange={(e) => setScheduleDate(e.target.value)}
            min={new Date().toISOString().split("T")[0]}
            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }}
          />
        </div>
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '8px' }}>Select Time</label>
          <input
            type="time"
            value={scheduleTime}
            onChange={(e) => setScheduleTime(e.target.value)}
            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }}
          />
          <p style={{ fontSize: '11px', color: '#666', marginTop: '5px' }}>
            ⏰ Schedule time must be at least 2 hours from now
          </p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={() => {
              onClose();
              setScheduleDate("");
              setScheduleTime("");
            }}
            style={{
              flex: 1,
              padding: '10px',
              backgroundColor: '#f5f5f5',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            style={{
              flex: 1,
              padding: '10px',
              backgroundColor: '#ee6521',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleOrderModal;